// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"1a29671f","64":"cf0f0150","419":"602e0f57","496":"da2e92b5","563":"00e3be64","906":"eed677cf","942":"b4795f7e"}[chunkId] + ".chunk.js";
};